import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';
import './Auth.css';

export default function MobileOnly() {
  const { logout, user } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="auth-page">
      <div className="auth-container" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>📱</div>
        <h1 className="auth-title">Используйте мобильное приложение</h1>
        <p className="auth-subtitle" style={{ marginBottom: 24 }}>
          {user?.role === 'Seller'
            ? 'Для продавцов доступно приложение 4mal Seller.'
            : 'Веб-версия доступна только для администраторов и модераторов.'}
        </p>
        <p className="auth-subtitle" style={{ marginBottom: 8 }}>
          Скачайте приложение <strong>4mal</strong> для iOS или Android, чтобы
          управлять фермами, животными и торговать на маркетплейсе.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', marginTop: 24 }}>
          <a
            href="https://apps.apple.com/kz/app/4mal/id6749147881"
            target="_blank"
            rel="noopener noreferrer"
            className="auth-button"
            style={{ textDecoration: 'none', padding: '12px 24px' }}
          >
            App Store
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=kz.mal.www.app&pli=1"
            target="_blank"
            rel="noopener noreferrer"
            className="auth-button"
            style={{ textDecoration: 'none', padding: '12px 24px' }}
          >
            Google Play
          </a>
        </div>
        <div className="auth-links">
          <button onClick={handleLogout} className="auth-link-button">
            Выйти из аккаунта
          </button>
        </div>
      </div>
    </div>
  );
}
